// @avantia common-code
import { ensureDefined, SMap } from '@avantia/client-and-server-utilities';
import { lodash } from '@avantia/lodash';
import { specialQuestionIds } from '../types';

export type HpQuestionIdMap = Record<string, string>;

export interface HpQuestionIdMapItem {
  questionIds: HpQuestionIdMap;
  sectionIds: HpQuestionIdMap;
}

const questionIdsMap: SMap<HpQuestionIdMapItem> = {
  '': createQuestionIdMap({ questions: {}, sections: {}, specialQuestionIds })
};

export function registerQuestionIds(data: SMap<HpQuestionIdMapItem>): void {
  lodash.keys(data).forEach((productId) => {
    const { questionIds, sectionIds } = data[productId];
    questionIdsMap[productId] = { questionIds, sectionIds };
  });
}

export function getQuestionIdFor(productId: string, questionName: string, mustFind?: boolean): string {
  let res = '';
  const map = questionIdsMap[productId];
  if (map !== undefined) {
    const id = map.questionIds[questionName];
    if (id !== undefined) {
      res = id;
    } else {
      res = mustFind == false ? id : ensureDefined(id, `questionIds.${questionName}`);
    }
  } else {
    ensureDefined(undefined, `questionIdsMap['${productId}']`);
  }

  return res;
}

export function getSectionIdFor(productId: string, sectionName: string): string {
  const id = questionIdsMap[productId].sectionIds[sectionName];
  return ensureDefined(id, `sectionIds.${sectionName}`);
}

export interface HpCreateQuestionIdMapProps {
  questions: SMap<{ name: string }>;
  sections: SMap<{ name?: string }>;
  specialQuestionIds?: readonly string[];
}

export function createQuestionIdMap({
  questions,
  sections,
  specialQuestionIds
}: HpCreateQuestionIdMapProps): HpQuestionIdMapItem {
  function getIdMap(map: SMap<{ name?: string }>) {
    const ids: SMap<string> = {};
    for (const id of lodash.keysIn(map)) {
      const item = map[id];
      if (item.name) {
        ids[item.name] = id;
      }
    }

    return ids;
  }

  const questionIds = getIdMap(questions);
  if (specialQuestionIds) {
    specialQuestionIds.forEach((id) => {
      questionIds[id] = id;
    });
  }

  return {
    questionIds,
    sectionIds: getIdMap(sections)
  };
}
